module.exports = __webpack_public_path__ + "img/infrasel_7.7df798f1.png";